import { combineReducers, Store, Reducer } from 'redux';
import { layoutReducer } from '@/redux/slices/layout';
import { payoutStructureReducer } from '@/redux/slices/payoutStructure';
import { authReducer } from '@/redux/slices/auth';
import { confirmationReducer } from '@/redux/slices/confirmation';
import tournamentFiltersReducer from '@/redux/slices/tournamentFiltersSlice';
import sngFiltersReducer from '@/redux/slices/sngFiltersSlice';
import { configureStore } from '@reduxjs/toolkit';
import { api } from '@/redux/api/base';
import logger from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import rootSaga from '@/redux/sagas/root';
import { walletTransfersReducer } from '@/pages/wallets/wallet-transfers-slice';
import { confirmationMiddleware } from '@/redux/middleware/confirmationMiddleware';
import { bulkTransferReducer } from '@/redux/slices/bulkTransferSlice';
import leaderboardsReducer from '@/redux/slices/leaderboards';

const sagaMiddleware = createSagaMiddleware();

export type AppState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

const rootReducer: Reducer = combineReducers({
  [api.reducerPath]: api.reducer,

  auth: authReducer,
  Layout: layoutReducer,
  confirmation: confirmationReducer,
  tournamentFilters: tournamentFiltersReducer,
  sngFilters: sngFiltersReducer,

  // pages
  payoutStructure: payoutStructureReducer,
  walletTransfers: walletTransfersReducer,
  bulkTransfer: bulkTransferReducer,
  leaderboards: leaderboardsReducer,
});

const store: Store<AppState> = configureStore({
  reducer: rootReducer,
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      confirmationMiddleware, // this needs to run before the saga middleware
      sagaMiddleware,
      api.middleware,
      logger,
    ),
});

sagaMiddleware.run(rootSaga);

export default store;
